var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
function IconStar(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 20 20" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10 1.75a.75.75 0 01.673.418l2.176 4.41 4.867.708a.75.75 0 01.416 1.279l-3.522 3.433.832 4.847a.75.75 0 01-1.089.791L10 15.347l-4.353 2.289a.75.75 0 01-1.088-.79l.831-4.848-3.522-3.433a.75.75 0 01.416-1.28l4.867-.707 2.177-4.41A.75.75 0 0110 1.75zm0 2.445l-1.679 3.4a.75.75 0 01-.564.411l-3.754.546 2.716 2.647a.75.75 0 01.216.664L6.294 15.6l3.357-1.765a.75.75 0 01.698 0l3.357 1.765-.64-3.738a.75.75 0 01.215-.664l2.716-2.647-3.754-.546a.75.75 0 01-.564-.41L10 4.195z", clipRule: "evenodd" })));
}
export default IconStar;
